import { combineReducers } from "redux";
import usager from "./usager";
import actionSociale from "./actionSociale";

export default combineReducers({
    usager,
    actionSociale
});
